<article [class]="displayElement.enableEditingNote ? 'agpr-chartCard' : 'agpr-chartCard agpr-chartCard-disabled'">
    <div class="agpr-chartCard-info">
        <div class="agpr-chartCard-container">
            <span
                [class]="displayElement.enableEditingNote? (chart?.type?.icon + ' agpr-chartCard-info-icon') : (chart?.type?.icon + ' agpr-chartCard-info-icon agpr-chartCard-info-icon-disabled')"
                aria-hidden="true"
            ></span>
            <div class="agpr-chartCard-info-items">
                <div [class]="displayElement.enableEditingNote ? 'agpr-chartCard-info-titleContainer agpr-chartCard-info-titleContainer-extraMargin': 'agpr-chartCard-info-titleContainer'">
                <span [class]="displayElement.enableEditingNote ? 'agpr-chartCard-info-title' : 'agpr-chartCard-info-title agpr-chartCard-info-title-disabled'">
                    {{ displayElement.title | localize }}
                </span>
                @if (displayElement.enableEditingNote) {
                    <span class="agpr-chartCard-info-dateRange">
                        {{ dateRangeLabel | localize }}
                    </span>
                }
                </div>
                @if (displayElement.enableEditingNote) {
                    <div class="agpr-chartCard-info-description">
                        <span class="agpr-chartCard-info-sourceContainer" *ngFor="let series of displayElement._series">
                            <agpr-button class="agpr-chartCard-info-source" [style]="buttonTypes.link"
                                tooltip="Reports.sharedReportSetupDialog.charts.source.tooltip" tooltipPosition="top"
                                [ariaLabel]="series.label + '. ' + ('Reports.sharedReportSetupDialog.charts.source.tooltip' | localize)"
                                (click)="goToSeriesSource(series)">
                                {{ series.label | localize }}
                            </agpr-button>
                            <span class="fa-regular fa-arrow-up-right-from-square agpr-chartCard-info-nav" aria-hidden="true"></span>
                        </span>
                    </div>
                }
                @if (chartAnnotationEnabled) {
                    <agpr-checkbox
                        class="agpr-chartCard-displayAnnotationInExport"
                        [id]="id + '_displayAnnotation'"
                        label="Reports.annotation.displayAnnotationInReport"
                        [binary]="true"
                        [(ngModel)]="displayElement.displayAnnotationInExport"
                    ></agpr-checkbox>
                }
                <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                @if (displayElement.enableEditingNote) {
                <div class="agpr-chartCard-notes" (keyup)="onKeyup($event)">
                    <div>
                        {{ 'Reports.sharedReportSetupDialog.charts.note' | localize }}
                        <span role="img" class="agpr-chartCard-notes-tooltip fa-regular fa-circle-info"
                            agprTooltip="Reports.sharedReportSetupDialog.charts.note.tooltip"></span>
                    </div>
                    <!-- b/e only allows 3072 chars -->
                    @if (selected && editing) {
                        <agpr-rich-text-editor-ck
                            [richTextEditorConfig]="ckEditorConfig"
                            [formatOptions]="defaultEditorStyles"
                            [maxChars]="3072" [(ngModel)]="displayElement.note"
                            (escapeEditor)="setEditing(false)"
                            [addIdToEditableArea]="true"
                        ></agpr-rich-text-editor-ck>
                    } @else {
                        <button
                            [id]="id + '_notes_button'"
                            class="agpr-chartCard-notes-editableBox agpr-contextMenu-parent"
                            (click)="setEditing(true)"
                            [agprTooltip]="displayElement.note? '' : 'Reports.sharedReportSetupDialog.charts.note.editTooltip'"
                            tooltipPosition="top"
                        >
                            <span *ngIf="!displayElement.note" class="agpr-chartCard-notes-editableBox-placeholder">
                                {{'Reports.sharedReportSetupDialog.charts.note.placeholder' | localize }}
                            </span>
                            @if (displayElement.note) {
                                <div class="agpr-chartCard-notes-preview-content">
                                <p [innerHTML]="displayElement.note | sanitizeHtml"></p>
                                <div class="agpr-contextMenu top right">
                                    <agpr-button
                                        [id]="id + '_editNote_button'"
                                        [icon]="'fa-regular fa-duotone fa-pen'"
                                        [tooltip]="'Reports.sharedReportSetupDialog.charts.note.editTooltip' | localize"
                                        (click)="editVal(true)"
                                        tooltipPosition="top"
                                        [style]="buttonTypes.contextMenu"
                                    ></agpr-button>
                                </div>
                            </div>
                            }
                        </button>
                    }
                </div>
                }
            </div>
        </div>

    </div>
</article>
